<div class="form-group product__option" fxLayout="row" fxLayoutAlign="center center">
  <div class="form-group" fxLayout="column" fxLayoutAlign="space-around center">
    <mat-form-field appearance="fill">
      <mat-label>Select a Time</mat-label>
      <input matTimepicker #t1="matTimepicker" #time1="ngModel" [minDate]="availableFrom" [maxDate]="availableTo"
        id="timepicker1" mode="24h" ngModel placeholder="Please select time..." name="time-1"
        (timeChange)="onSelect($event)">
      <mat-icon matSuffix (click)="t1.showDialog()">access_time</mat-icon>
      <mat-error *ngIf="time1.touched && time1.invalid">Invalid Date</mat-error>
    </mat-form-field>
  </div>